import { ChartAreasplineIcon } from './ChartAreasplineIcon';

/**
 * author: Austin Andrews
 * id 00654F5E-1B8B-4BD7-933B-0BD65B2C9BAC
 * name chart-areaspline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-areaspline.svg
 * tags
 * - Math 
 */
export const ReportAreasplineIcon = ChartAreasplineIcon;
export default ReportAreasplineIcon